import _forEach from 'lodash/forEach';

export const findElement = selector => {
  const max = 20;
  let retries = 0;
  return new Promise(res => {
    const interval = setInterval(() => {
      const elem = document.querySelector(selector);
      if (elem || retries > max) {
        res(elem);
        clearInterval(interval);
      } else {
        retries += 1;
      }
    }, 500);
  });
};

export const replacePlaceholders = (string, placeholdersMap) => {
  const placeholdersStr = Object.keys(placeholdersMap).join('|');
  const regex = new RegExp(placeholdersStr, 'gi');
  const result = [];
  let str = '';

  _forEach(string, symbol => {
    str += symbol;
    const match = str.match(regex);

    if (match) {
      const isExact = str === match[0];
      if (isExact) {
        result.push(placeholdersMap[match[0]]);
      } else {
        result.push(
          ...str.split(match[0]).map(s => s || placeholdersMap[match[0]]),
        );
      }

      str = '';
    }
  });

  return result.length > 0 ? result.join('') : string;
};
